export enum ValidationMessage {
  Required = 'This field cannot be empty, it is required.',
  ABNRequiredIfEntityEmpty = 'This field cannot be empty, it is required if Entity name is empty.',
  EntityRequiredIfABNEmpty = 'This field cannot be empty, it is required if ABN is empty.',
}
